/*eslint no-console: "off"*/
// we have disabled eslint no-console rule since it is mandatory here to use console log method
import { ConfigService } from '../../Configs/ConfigService';
import { LoggerInterface, LogData, LoggerData } from '../types/LoggerTypes';

const transformLog = (data: LogData[], level: string) => {
  const [loggerObj, ...rest] = data as [LoggerData, LogData[]];
  const configs = ConfigService.getConfigs();

  const logData: { [key: string]: unknown } = {
    message: null,
    'log.level': level,
    IMAGE_TAG: configs.IMAGE_TAG,
    'log.type': 'CONSOLE_LOGS',
  };

  const logObject = {
    component: loggerObj.component,
    product: loggerObj.product,
  };

  const isLogObjectEmpty = !loggerObj.component && !loggerObj.product;

  if (level === 'ERROR') {
    logData['err.message'] = rest;
    logData['message'] = !isLogObjectEmpty ? [logObject] : [];
  } else {
    logData['message'] = !isLogObjectEmpty ? [logObject, ...rest] : rest;
  }

  logData['log.logger'] = loggerObj?.page ? loggerObj?.page : loggerObj?.component;

  return typeof window !== 'undefined' ? logData : JSON.stringify(logData);
};

export const ConsoleLogger: LoggerInterface = {
  log: (...data: LogData[]) => console.log(transformLog(data, 'LOG')),
  info: (...data: LogData[]) => console.info(transformLog(data, 'INFO')),
  warn: (...data: LogData[]) => console.warn(transformLog(data, 'WARN')),
  error: (...data: LogData[]) => console.error(transformLog(data, 'ERROR')),
  debug: (...data: LogData[]) => console.debug(transformLog(data, 'DEBUG')),
};
